// extracted by mini-css-extract-plugin
export default {"formItem":"ProjectCustomizeForm_formItem__hjJ4Q","label":"ProjectCustomizeForm_label__byTWV"};